function initializeAtharNavigation(root = document) {
  root.querySelectorAll('.athar-header__drawer').forEach((drawer) => {
    if (drawer.dataset.atharNavigationReady === 'true') return;
    drawer.dataset.atharNavigationReady = 'true';
    const summary = drawer.querySelector('.athar-header__menu-button');
    const panel = drawer.querySelector('.athar-header__panel');
    if (!(summary instanceof HTMLElement) || !(panel instanceof HTMLElement)) return;
    const hoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    let pinnedOpen = false;
    let closeTimer;
    const cancelClose = () => window.clearTimeout(closeTimer);
    const syncState = () => {
      summary.setAttribute('aria-expanded', String(drawer.open));
      summary.setAttribute('aria-label', drawer.open ? 'Close navigation' : 'Open navigation');
    };
    const closeDrawer = (restoreFocus = false) => {
      cancelClose();
      pinnedOpen = false;
      drawer.open = false;
      syncState();
      if (restoreFocus) summary.focus();
    };
    // A click pins a hover-open menu instead of letting details toggle it closed.
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      cancelClose();
      if (pinnedOpen) {
        closeDrawer();
      } else {
        pinnedOpen = true;
        drawer.open = true;
        syncState();
      }
    });
    drawer.addEventListener('toggle', syncState);
    drawer.addEventListener('pointerenter', (event) => {
      cancelClose();
      if (event.pointerType !== 'mouse' || !hoverPointer.matches) return;
      drawer.open = true;
      syncState();
    });
    drawer.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse' || !hoverPointer.matches) return;
      closeTimer = window.setTimeout(() => {
        if (!pinnedOpen) closeDrawer();
      }, 180);
    });
    drawer.addEventListener('focusin', cancelClose);
    drawer.addEventListener('focusout', (event) => {
      if (event.relatedTarget && !drawer.contains(event.relatedTarget)) closeDrawer();
    });
    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.open) {
        event.preventDefault();
        closeDrawer(true);
      } else if (event.key === 'ArrowDown' && event.target === summary) {
        event.preventDefault();
        pinnedOpen = true;
        drawer.open = true;
        syncState();
        panel.querySelector('a[href]')?.focus();
      }
    });
    panel.querySelectorAll('a[href]').forEach((link) => {
      link.addEventListener('click', () => window.setTimeout(() => closeDrawer(), 0));
    });
    document.addEventListener('pointerdown', (event) => {
      if (drawer.open && !drawer.contains(event.target)) closeDrawer();
    });
    syncState();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeAtharNavigation());
} else {
  initializeAtharNavigation();
}
document.addEventListener('shopify:section:load', (event) => initializeAtharNavigation(event.target));
